(function () {
  if (window.__vloergigantUpsellBlockInit) return;
  window.__vloergigantUpsellBlockInit = true;

  function clampQty(val) {
    const n = Math.max(1, parseInt(val, 10) || 1);
    return n;
  }

  // +/− knoppen + manuele input van qty selectors in de upsell-card.
  document.addEventListener('click', function (evt) {
    const decBtn = evt.target.closest('[data-upsell-qty-decrease]');
    const incBtn = evt.target.closest('[data-upsell-qty-increase]');
    if (!decBtn && !incBtn) return;

    const card = (decBtn || incBtn).closest('[data-upsell-card]');
    if (!card) return;
    const input = card.querySelector('[data-upsell-qty-input]');
    if (!input) return;

    const current = clampQty(input.value);
    input.value = String(decBtn ? Math.max(1, current - 1) : current + 1);
  });

  document.addEventListener('input', function (evt) {
    const input = evt.target.closest('[data-upsell-qty-input]');
    if (!input) return;
    // Allow free typing tijdens input; bij blur clampen
  });
  document.addEventListener('change', function (evt) {
    const input = evt.target.closest('[data-upsell-qty-input]');
    if (!input) return;
    input.value = String(clampQty(input.value));
  });

  // Add-knop: AJAX add met qty uit zelfde card.
  document.addEventListener('click', async function (evt) {
    const btn = evt.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;

    evt.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const card = btn.closest('[data-upsell-card]');
    const qtyInput = card ? card.querySelector('[data-upsell-qty-input]') : null;
    const quantity = qtyInput ? clampQty(qtyInput.value) : 1;

    btn.disabled = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!res.ok) throw new Error('cart/add failed');

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1400);
    } catch (err) {
      console.error(err);
      alert('Dit product kon niet worden toegevoegd.');
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });
})();
